<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <div class="d-none d-md-block">
            <base-button size="sm" type="neutral" @click="create" v-if="owner">New</base-button>
            <base-button size="sm" type="neutral" v-b-toggle.filters>
              <span class="btn-inner--icon"><i class="fas fa-filter"></i></span>
              <span class="btn-inner--text">Filters</span>
            </base-button>
            <base-button size="sm" type="neutral" v-b-toggle.stats>
              <span class="btn-inner--icon"><i class="fas fa-chart-pie"></i></span>
              <span class="btn-inner--text">Stats</span>
            </base-button>
          </div>
          <div class="d-block d-md-none">
            <b-dropdown size="sm" variant="neutral" id="transaction-actions" text="Actions" class="m-md-2">
              <b-dropdown-item @click="create" v-if="owner">New</b-dropdown-item>
              <b-dropdown-item v-b-toggle.filters>Filters</b-dropdown-item>
              <b-dropdown-item v-b-toggle.stats>Stats</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-collapse visible id="stats">
        <listing-stats
          :year="year"
          :status="status"
          :searchQuery="searchQuery"
          :orderBy="sortBy"
          :userRoute="userRoute">
        </listing-stats>
      </b-collapse>

      <listing-table 
        :title="title"
        :data="listings"
        :tableColumns="columns"
        :propsToSearch="propsToSearch"
        :statuses="statuses"
        :variants="variants"
        :canAddEdit="owner"
        :userRoute="userRoute"
        :orderBy="sortBy"
        :orderDesc="sortDesc"
        :isBusy="isBusy"
        :pagination="pagination"
        @updateYear="updateYear"
        @getItems="getItems"
        @updateStatus="updateStatus"
        @pageChange="pageChange"
        @perPageChange="perPageChange"
        @search="search"
        @sort="sortItems"
        @exportListings="exportListings"
        v-if="listings"></listing-table>
        <loading-panel v-else class="mt-6"></loading-panel>
    </b-container>
  </div>
</template>
<script>
// Components
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import LoadingPanel from '@/components/LoadingPanel';
import ListingStats from '@/views/Components/Stats/ListingStats';
import ListingTable from '@/views/Components/Tables/ListingTable';
import columns from './columns';
import paginationMixin from '@/views/Components/Tables/PaginatedTables/transactionPaginationMixin';

export default {
  mixins: [paginationMixin],
  components: {
    RouteBreadCrumb,
    LoadingPanel,
    ListingStats,
    ListingTable
  },
  data() {
    return {
      listings: null,
      columns: columns,
      propsToSearch: [],
      year: new Date().getFullYear(),
      sortBy: 'close_date',
      sortDesc: false,
      status: '',
      statuses: [
        {
          value: 'coming-soon',
          label: 'Coming Soon'
        },
        {
          value: 'active',
          label: 'Active'
        },
        {
          value: 'expired',
          label: 'Expired'
        },
        {
          value: 'cancelled',
          label: 'Cancelled'
        }
      ],
      variants: {
        'coming-soon': 'info',
        active: 'success',
        expired: 'warning',
        cancelled: 'danger'
      },
      isBusy: false
    };
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    title() {
      return 'Listings';
    },
    owner() {
      const roles = this.$store.getters['roles/roles'];
      return roles[0] == 'owner';
    }
  },
  methods: {
    async getItems(year) {
      this.isBusy = true;
      const params = "?page=" + this.pagination.currentPage + "&perPage=" + this.pagination.perPage + "&year=" + year + "&status=" + this.status + "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc + "&searchQuery=" + this.searchQuery;
      
      axios.get(this.userRoute + "/listings" + params)
        .then(response => {
          this.listings = response.data.data;
          this.pagination.total = response.data.meta.total;
          this.pagination.from = response.data.meta.from;
          this.pagination.to = response.data.meta.to;
          this.isBusy = false;
        });
    },
    create() {
      this.$router.push({path: '/listings/create'});
    },
    async exportListings() {
      const params = "?year=" + this.year + "&status=" + this.status + "&searchQuery=" + this.searchQuery;

      axios.get(this.userRoute + "/export-listings" + params)
      .then(response => {
        swal.fire({
          title: 'Export Complete',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Listings',
        }).then(result => {
          if (result.value) {
            window.open(response.data.link, "_blank");
          }
        });
      })
      .catch(error => {
        // 
      });
    }
  },
  created() {
    this.getItems(this.year);
  },
  mounted() {
    document.title = this.title + " | ClarityNOW";
  }
};
</script>